import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { clientData } = useAuth();

  // If not authenticated, redirect to login
  if (!clientData) {
    return <Navigate to="/login" replace />;
  }

  // Else render child routes
  return <Outlet />;
};

export default ProtectedRoute;
